import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { extra } from "@/content-extra";

export default function NotFound() {
  const { lang } = useLang();
  const nf = extra[lang].notFound;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <img src="/assets/logo.png" alt="VPS Group" className="h-12 w-auto mb-10" />
      <p className="font-display font-bold text-8xl text-volt tracking-tighter" data-testid="not-found-code">404</p>
      <h1 className="mt-4 font-display font-bold text-2xl sm:text-3xl">{nf.title}</h1>
      <p className="mt-3 text-steel max-w-md">{nf.text}</p>
      <Link to="/" className="btn-primary mt-8" data-testid="not-found-home-button">{nf.back}</Link>
    </div>
  );
}
